module.exports = __webpack_public_path__ + "static/paczki_osobno_gold-fe7c76e1bbde42e20ca4361ea990cc31.png";